import { authHeader, handleResponse } from 'helpers';
import { apiConstants } from '../constants';
import { queryFilters, queryWhere } from '../helpers/util';

export const functionalityService = {
  getAll
};

function getAll(limit, page, filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getFunctionalities;
  var funcFilters = queryFilters(limit, page);
  if (filters) funcFilters = funcFilters.concat('', queryWhere(filters));
  return fetch(`${url}${funcFilters}`, requestOptions)
    .then(handleResponse);
}
